var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPieChartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9232",
    "data-name": "Group 9232",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.576,
    height: 33.578,
    viewBox: "0 0 33.576 33.578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3130",
    "data-name": "Rectangle 3130",
    width: 33.576,
    height: 33.578,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9231",
    "data-name": "Group 9231",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M16.793,38.264H29.856a1.2,1.2,0,0,1,1.314.982,4.333,4.333,0,0,1,.011.9,15.185,15.185,0,0,1-1.96,6.866,15.411,15.411,0,0,1-7.438,6.773,15.257,15.257,0,0,1-4.508,1.184,14.955,14.955,0,0,1-5.952-.495,16.747,16.747,0,0,1-3.79-1.677A15.653,15.653,0,0,1,1.5,46.105,15.331,15.331,0,0,1,.176,41.7a14.652,14.652,0,0,1-.144-3.267,15.162,15.162,0,0,1,1.34-5.4,15.457,15.457,0,0,1,6.119-6.905A14.809,14.809,0,0,1,13.3,24.058c.747-.1,1.5-.154,2.255-.184a1.171,1.171,0,0,1,1.234,1.238q0,6.439,0,12.878v.274M14.4,26.338A13.182,13.182,0,1,0,28.707,40.658H15.776a1.322,1.322,0,0,1-1.086-.449,1.438,1.438,0,0,1-.291-.965q0-6.318,0-12.635v-.271",
    transform: "translate(0 -21.486)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M192.113,7.136q0-2.887,0-5.773A1.278,1.278,0,0,1,193.665.012c.459.047.921.067,1.378.125a12.448,12.448,0,0,1,4.49,1.457,13.166,13.166,0,0,1,5.052,4.763,13.575,13.575,0,0,1,1.638,4.354,11.439,11.439,0,0,1,.257,2.356,1.143,1.143,0,0,1-.581,1.084,1.818,1.818,0,0,1-.8.2c-3.861.013-7.723.009-11.584.008a1.277,1.277,0,0,1-1.4-1.4q0-2.915,0-5.83m11.95,4.837c-.056-.33-.1-.644-.165-.953a12.748,12.748,0,0,0-.968-2.764,9.811,9.811,0,0,0-2.022-2.724,10.674,10.674,0,0,0-6.156-3.056c-.267-.039-.268-.04-.268.223q0,4.526,0,9.052v.223Z",
    transform: "translate(-172.904 0)",
    fill: "#0094d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChartIcon);
export default __webpack_public_path__ + "static/media/pie-chart-icon.e07021a1bfa9864e9e2d9dc5f542f998.svg";
export { ForwardRef as ReactComponent };